<template>
    <div class="wrapper">
        <div class="page-header page-header-mini" v-if="!headerSimple">
            <parallax class="page-header-image" v-bind:style="{ backgroundImage: 'url(' + mensaje('img1') + ')' }">
            </parallax>
        </div>
        
        <div class="page-head2 page-header-mini" v-if="headerSimple" :style="{ marginBottom: `${logo_altura}px` }">
        </div>
        
        <div class="section">
            <div class="container">

                <div class="section" v-if="mensaje('bloque1activo')==true">
                    <div class="row">
                        <div class="col-md-8 ml-auto mr-auto text-center mr-5">
                            <h2 class="title">{{mensaje('tit1')}}</h2>
                            <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-150%); line-height: normal;">producto.json->[]mensajes:tit1</span>
                            <h4 class="description" v-html="mensaje('tit2')"></h4>
                            </p>
                            <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-100%); line-height: normal;">producto.json->[]mensajes:tit2 <i>HTML</i></span>
                        </div>
                    </div>
                    <div class="section-story-overview">
                        <div class="row">
                            <div class="col-md-4 ml-auto mr-auto">
                                <div class="image-container image-left" v-bind:style="{ backgroundImage: 'url(' + mensaje('img2') + ')' }">
                                  <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,50%); line-height: normal;">producto.json->[]mensajes:img2</span>
                                    <!-- First image on the left side -->
                                    <p class="blockquote blockquote-primary" v-if="mensaje('com1').activo==true">{{mensaje('com1').comentario}}
                                      <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-50%); line-height: normal;">producto.json->[]mensajes:com1:comentario</span>
                                        <br>
                                        <br>
                                        <small>{{mensaje('com1').cliente}}</small>
                                        <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,50%); line-height: normal;">producto.json->[]mensajes:com1:cliente</span>
                                    </p>
                                </div>
                                <!-- Second image on the left side of the article -->
                                <div class="image-container" v-bind:style="{ backgroundImage: 'url(' + mensaje('img3') + ')' }">
                                  <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,50%); line-height: normal;">producto.json->[]mensajes:img3</span>
                                </div>
                                
                            </div>
                            <div class="col-md-4 ml-auto mr-auto">
                                <!-- First image on the right side, above the article -->
                                <div class="image-container image-right"
                                     v-bind:style="{ backgroundImage: 'url(' + mensaje('img4') + ')' }"><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,50%); line-height: normal;">producto.json->[]mensajes:img4</span></div>
                                <h3>{{mensaje('tit3')}}</h3>
                                <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-150%); line-height: normal;">producto.json->[]mensajes:tit3</span>
                                <p v-html="mensaje('parrafo1')">
                                </p>
                                <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-10%,-150%); line-height: normal;">producto.json->[]mensajes:parrafo1 <i>HTML</i></span>
                                
                                <p v-html="mensaje('parrafo2')">
                                </p>
                                <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(20%,-100%); line-height: normal;">producto.json->[]mensajes:parrafo2 <i>HTML</i></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="features-4" v-if="mensaje('bloque2activo')==true">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-8 ml-auto mr-auto text-center">
                                <h2 class="title">{{mensaje('tit4')}}</h2>
                                <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-150%); line-height: normal;">producto.json->[]mensajes:tit4</span>
                                <h4 class="description" v-html="mensaje('men2')"></h4>
                                <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-100%); line-height: normal;">producto.json->[]mensajes:men2 <i>HTML</i></span>
                            </div>
                        </div>
                        <div class="row">
                          <div class="col-md-4" v-for="modulo1 in modulos1">
                            <div class="card card-background card-raised" data-background-color
                                 v-bind:style="{ backgroundImage: 'url(' + modulo1.fondo + ')' }">
                                 <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-150%,70%); line-height: normal; z-index: 9999;">producto.json->[]modulo1:fondo</span>
                                <div class="info">
                                  <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(30%,10%); line-height: normal; z-index: 9999;">producto.json->[]modulo1:icono</span>
                                    <div class="icon icon-white">
                                        <i class="now-ui-icons" v-bind:class="modulo1.icono"></i>
                                    </div>
                                    <div class="description">
                                        <h4 class="info-title">{{modulo1.titulo}}</h4>
                                        <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(30%,-150%); line-height: normal; z-index: 9999;">producto.json->[]modulo1:titulo</span>
                                        <p v-html="modulo1.descripcion"></p>
                                        <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(30%,-100%); line-height: normal; z-index: 9999;">producto.json->[]modulo1:descripcion <i>HTML</i></span>
                                    </div>
                                </div>
                            </div>
                          </div> 
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section related-products" data-background-color="black">
            <div class="container">
                <h3 class="title text-center">{{mensaje('tit5')}}<span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,10%); line-height: normal;">producto.json->[]mensajes:tit5</span></h3>
                <div class="row">
                  <div class="col-sm-6 col-md-3" v-for="modulo2 in modulos2" style="display: flex;">
                      <card type="product" style="flex-direction: column;">
                        <img slot="image" class="img rounded" v-bind:src="modulo2.foto"/>
                        <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(30%,-300%); line-height: normal;">producto.json->[]modulo2:foto</span>
                        <h6 class="category text-danger">{{modulo2.tipo}}</h6>
                        <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(30%,-80%); line-height: normal;">producto.json->[]modulo2:tipo</span>
                        <h4 class="card-title">
                          {{modulo2.nombre}}
                        </h4>
                        <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(30%,-140%); line-height: normal;">producto.json->[]modulo2:nombre</span>
                        <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(30%,20%); line-height: normal;">producto.json->[]modulo2:descripcion <i>HTML</i></span>
                        <div class="card-description" style="flex: 1 0 auto;" v-html="modulo2.descripcion">
                        </div>
                        <div class="card-footer" style="text-align: right;">
                          <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-100%,40%); line-height: normal;">producto.json->[]modulo2:precio</span>
                          <div class="price-container">
                              <span class="price">{{modulo2.precio}}</span>
                          </div>
                        </div>
                      </card>
                  </div> 
                  
                </div>
            </div>
        </div>

    </div>
</template>
<script>
  import { Card, Button, Collapse, CollapseItem } from '@/components';
  import { Carousel, CarouselItem, Select, Option, Tooltip } from 'element-ui'
  import {RUTA_BASE} from '@/constants'
  import axios from "axios"

  export default {
    name: 'producto',
    bodyClass: 'product-page',
    components: {
      Card,
      Collapse,
      CollapseItem,
      [Button.name]: Button,
      [Carousel.name]: Carousel,
      [CarouselItem.name]: CarouselItem,
      [Select.name]: Select,
      [Option.name]: Option,
      [Tooltip.name]: Tooltip,
    },
    data() {
      return {
        filters: {
          color: '',
          size: ''
        },
        id: this.$route.params.userId,
        mensajes: [],
        year: new Date().getFullYear(),
        modulos1: [],
        modulos2: [],
        headerSimple: false,
        logo_altura: 0,
      }
    },
    watch: {
      '$store.state.idioma': {
        handler(newValue, oldValue) {
          // Acciones a realizar cuando la variable cambia
          console.log('La variable ha cambiado', newValue)
          this.cambiaIdioma(newValue)
        },
        deep: true, // Opcional: vigila cambios profundos en la variable
      },
    },
    methods: {
      cambiaIdioma(nuevoValor) {
        var vid = parseInt(this.id)
        var numIdioma = this.$store.state.idiomas[nuevoValor]
        var cadJson = 'json/producto'+numIdioma.toString()+'.json'
        axios.get(RUTA_BASE+cadJson)
        .then(response => {
          this.mensajes = response.data.array[vid].mensajes
          this.modulos2 = response.data.array[vid].modulos2
          this.modulos1 = response.data.array[vid].modulos1
        })
        .catch(error => console.log(error))
      },
      mensaje(nom) {
          var mens = ''
          this.mensajes.forEach(elemento => {
            if (elemento.nombre==nom) {
              mens = elemento.mensaje
            }
          })
          return(mens)
        }
      },
      mounted() {
        var vid = parseInt(this.id)
        this.headerSimple = this.$store.state.header_simple
        this.logo_altura = this.$store.state.logo_altura
        var numIdioma = this.$store.state.idiomas[this.$store.state.idioma]
        var cadJson = 'json/producto'+numIdioma.toString()+'.json'
        axios.get(RUTA_BASE+cadJson)
        .then(response => {
          //var datos = JSON.parse(response.data)
          console.log(response.data)
          console.log("vid: ",vid)
          //console.log ("mensajes: ",datos.array[vid])
            this.mensajes = response.data.array[vid].mensajes
            this.modulos2 = response.data.array[vid].modulos2
            this.modulos1 = response.data.array[vid].modulos1
            console.log("mensajes: ",this.mensajes)
            console.log("modulos2: ",this.modulos2)
        })
        .catch(error => console.log(error))
      }
  }
</script>
<style>
</style>
